export default __webpack_public_path__ + "static/media/work-history.f8127a79.svg";